module.exports = __webpack_public_path__ + "static/media/thrive-explore-taskbar.2762f3b6.png";